import React, { useState } from 'react'
import { Container,Row,Col } from 'react-bootstrap';
import { FiX, FiUpload } from "react-icons/fi"; // Close & Upload icons
import { FaStarOfLife } from "react-icons/fa6";
import './Add_installation.css';

import {useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import axios from "axios";
import Swal from "sweetalert2";
import dayjs from 'dayjs';
import { useRef } from "react";
import _, { orderBy } from 'lodash';

import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Order_Details({installDetails, setinstallDetails, isEditable ,names,setNames}) {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;


    const[installOrderDetails,setInstallOrderDetails]=useState({});

//  const [originalData, setOriginalData] = useState({});


console.log("Editable mode?", isEditable);

 




  const [routerMaterial, setRouterMaterial] = useState([]);


console.log(installDetails)

    const locate = useLocation();
        const [rows, setRows] = useState([]);
      
        const [isSubmitted, setIsSubmitted] = useState(false);
        // const [isEditable, setIsEditable] = useState(true);
        const [isEditMode, setIsEditMode] = useState(false);
    const staffName = useSelector((state) => state.staffname);
        const [ottData, setOttData] = useState([]);
    
  console.log(staffName)
    const formatDate = (date) => {
      return dayjs(date).format('DD-MM-YYYY');
    };
   // to track update mode
    const [originalComplaint, setOriginalComplaint] = useState(null);
    // const[installDetails,setinstallDetails]=useState({})
      const [originalData, setOriginalData] = useState({});
      const listView =()=> {
        axios
        .post(apiUrl + "viewlead", {})
        .then((res) => {
          setRows(res.data.message);
        })
        .catch((error) => {
          console.error("Error fetching data", error);
        });
      } 
    
      useEffect(() => {
        listView()
      }, []);
    
    useEffect(() => {
      axios
        .post(apiUrl+"getdata-install", {
          leadId: locate.state?.leadId,
        })
        .then((res) => {
          setinstallDetails(res.data.message);
          setOriginalData(res.data.message); // Store original data for comparison
        });
    }, [locate.state?.leadId]);
  
    const handleChange = (e) => {
      setinstallDetails({
        ...installDetails,
        [e.target.name]: e.target.value,
      });
    };
  
 
const handlePlanChange = (e) => {
  const { name, value } = e.target;

  const convertCurrencyStringToNumber = (str) => {
    const cleaned = str.replace(/[₹,]/g, '');
    return parseFloat(cleaned);
  };

  // ✅ Handle Router selection
  if (name === "installrouterModel") {
    const selectedRouter = routerMaterial.find((r) => r.materialType === value);
    const routerCost = selectedRouter ? selectedRouter.sellingCost : 0;

   setinstallDetails((prev) => ({
      ...prev,
      installplanDetails: {
        ...prev.installplanDetails,
        installrouterModel: value,
        installrouterCost: routerCost,
        routerSellingCost:routerCost,
      },
    }));
    return;
  }

  // ✅ Handle OTT Pack selection
  if (name === "installottPackDetails") {
    const selectedOtt = ottData.find((ott) => ott.ottDetail === value);
    const ottPrice = selectedOtt ? convertCurrencyStringToNumber(selectedOtt.ottPrice) : 0;

    setinstallDetails((prev) => ({
      ...prev,
      installplanDetails: {
        ...prev.installplanDetails,
        installottPackDetails: value,
        installottPrice: [ottPrice], // store as array
      },
    }));
    return;
  }

  // ✅ For all other fields
  setinstallDetails((prev) => ({
    ...prev,
    installplanDetails: {
      ...prev.installplanDetails,
      [name]: value,
    },
  }));
};










    const planMonth = Number(installDetails?.installplanDetails?.installplanMonth) ||0;
const planAmount = Number(installDetails?.installplanDetails?.installplanAmount) ||0;
const staticIpCost = Number(installDetails?.installplanDetails?.installstaticIpCost)||0;
const installationCost = Number(installDetails?.installplanDetails?.installinstalationCost)||0;
const routerCost = Number(installDetails?.installplanDetails?.installrouterCost)||0;
const otherCost = Number(installDetails?.installplanDetails?.installothersCost)||0;

const totalPlanAmount = planMonth * planAmount;

const baseAmount = totalPlanAmount + staticIpCost + installationCost + routerCost + otherCost;

const gstAmount = baseAmount * 0.18;

const orderValue = +(baseAmount + gstAmount).toFixed(2);

const plan = installDetails.installplanDetails || {};


const installrouterCost = Number(plan.routerSellingCost) || 0;
const installfiberCost = Number(plan.installfiberCost) || 0;
const installfiberCableMeter = Number(plan.installfiberCableMeter) || 0;
const installottPrice = Array.isArray(plan.installottPrice) ? Number(plan.installottPrice[0]) || 0 : 0;
const installothersCost = Number(plan.installothersCost) || 0;
const OrderScore = baseAmount
  - installrouterCost
  - (installfiberCableMeter * installfiberCost)
  - installottPrice
  - installothersCost;

console.log("OrderScore:", OrderScore);
console.log(baseAmount,'baseamout')


const formattedOrderValue = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR"
}).format(orderValue);



const formattedOrderScore = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR"
}).format(OrderScore);
  
    const [taskData, setTaskData] = useState({
      taskName: 'install',
      assignDateTime: '',
      taskType: '',
      taskPriority: '',
      deadline: '',
      time: '',
      assignedTo: [], // Array for multiple selections
      approvePerson: '',
      description: '',
      name:  '',
      leadId:  '',
      taskStatus: 'Open',
      assignedBy:''
    });
  
  
    useEffect(() => {
      if (staffName) {
        setTaskData((prev) => ({ ...prev, assignedBy: staffName }));
      }
    }, [staffName]);
  
    console.log(taskData.staffName)
  
  
    const handleInputChange = (field, value) => {
      setTaskData(prev => ({
        ...prev,
        [field]: value
      }));
    };
  
  
    const [selectedFile, setSelectedFile] = useState(null);
  
  
    const [isOpenAdvancePayment, setIsOpenAdvancePayment] = useState(false)
  
    // Handle file selection
    const handleFileChange = (event) => {
      setSelectedFile(event.target.files[0]);
    };
  
  
  
    const [isOpenplan, setIsOpenplan] = useState(false);
    const [isOpenConverted, setIsOpenConverted] = useState(false);
  
    const navigate = useNavigate();
  
  
  
  
    const [selectedNames, setSelectedNames] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
  
   
  
    // Close dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);
  
    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };
  
    const handleCheckboxChange = (name) => {
      setSelectedNames(prev =>
        prev.includes(name)
          ? prev.filter(n => n !== name)
          : [...prev, name]
      );
  
    };
  
    const displayText = selectedNames.length > 0
      ? selectedNames.join(', ')
      : 'Select names';
  
    // State initialization
  
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      if (isEditMode) {
        // ✅ Check if there are any changes
        if (_.isEqual(installDetails, originalComplaint)) {
          Swal.fire("No Changes", "No changes were made to update.", "info");
          return;
        }
      }
  
      const result = await Swal.fire({
        title: isEditMode ? "Update the changes?" : "Are you sure?",
        showCancelButton: true,
        confirmButtonText: isEditMode ? "Update" : "Submit",
      });
  
      if (result.isConfirmed) {
        try {
          if (isEditMode) {
            await axios.post(
              apiUrl+"update-lead-install",
              installDetails,
              { headers: { "Content-Type": "application/json" } }
            );
            Swal.fire("Updated!", "Data updated successfully", "success");
          } 
  
          // setIsEditable(false);
          setIsEditMode(false);
        } catch (error) {
          Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
        }
      }
    };
  
  
    const handleAmountChange = (e) => {
      const { name, value } = e.target;
      setinstallDetails(prevState => ({
        ...prevState,
        installplanDetails: {
          ...prevState.installplanDetails,
          installadvanceAmount: {
            ...prevState.installplanDetails.installadvanceAmount,
            [name]: value
          }
        }
      }));
    };
  
  
    const handleLeadChange = (e) => {
      const { name, value } = e.target;
      setinstallDetails(prevState => ({
        ...prevState,
        installleadStatus: {
          ...prevState.installleadStatus,
          [name]: value
        }
      }));
    };
  
  
  
    const handleSubmitAssignTask = async (e) => {
      e.preventDefault();
  
  
      Swal.fire({
        title: "Do you want to save the Task Assign Details?",
        showCancelButton: true,
        confirmButtonText: "Save",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
  
            const datas = { ...taskData, assignedTo: selectedNames }
  
            const response = await axios.post(
              apiUrl+"add-assign-task",
              datas,
              { headers: { "Content-Type": "application/json" } }
            );
  
            Swal.fire({
              title: "Customer Details Added Successfully!",
              icon: "success",
            }).then(() => {
              navigate("/install");
            });
          } catch (error) {
            console.log("Error submitting data:", error.response?.data || error.message);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.response?.data?.message || "Something went wrong!",
            });
          }
        }
      });
    };
   useEffect(() => {
      const now = new Date();
    
      const dd = String(now.getDate()).padStart(2, '0');
      const mm = String(now.getMonth() + 1).padStart(2, '0');
      const yyyy = now.getFullYear();
    
      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, '0');
    
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 becomes 12
      const hh = String(hours).padStart(2, '0');
    
      const formattedDateTime = `${dd}-${mm}-${yyyy} / ${hh}:${minutes} ${ampm}`;
    
      setTaskData(prev => ({
        ...prev,
        assignDateTime: formattedDateTime,
      }));
    }, []);
  
  
  
  
   useEffect(() => {
    axios.post(apiUrl + "viewott", {}).then((res) => {
      const add_installation = res.data.message || [];
      console.log("Fetched data:", add_installation); // ✅ Check this output

      setOttData(add_installation);


    });




  }, []);

  
  useEffect(() => {
    axios.get(apiUrl + "/router-selling/all", {}).then((res) => {
      const add_installation = res.data || [];
      console.log("Fetched data:", add_installation); // ✅ Check this output

      setRouterMaterial(add_installation);


    });
  }, []);


  useEffect(() => {
    axios.get(apiUrl + "/get_fibermetersellingcost").then((res) => {
      const data = res.data;
      const fiberData = Array.isArray(data) && data.length > 0 ? data[0] : null;
  
      setinstallDetails((prev) => ({
        ...prev,
        installplanDetails: {
          ...prev.installplanDetails,
          installfiberCost: fiberData?.fibermetersellingcost || 0,
        },
      }));
    });
  }, []);



  return (
    <div>

<Container className="mt-1   ">
                <form >
                    
                        <div  className='plan-details-container-border mt-3 text-center'>
                            <p style={{ fontSize:"13px"}}  className='pt-2'><span className='text-primary'>{installDetails?.installplanDetails?.installfiberCableMeter}
                            </span> M, <span className='text-primary '>{installDetails?.installplanDetails?.installplanSpeed}
                            </span> Mbps, <span className='text-primary'> {installDetails?.installplanDetails?.installplanMonth}</span>Month @ <span className='text-primary'>Rs. {installDetails?.installplanDetails?.installplanAmount}
                            /-</span></p>
                            <p  style={{ fontSize:"13px"}}>Order Value @ <span className='text-primary'>Rs.{formattedOrderValue}/-</span>, OrderScore @ <span className='text-primary'>Rs.{formattedOrderScore}/-</span></p>
                            
                        </div>
                    

                        <div className="">
            <Row className="text-start lead-id-row  mb-4 mt-4 ms-4 "disabled={!isEditable}
  // Disable cancel button when not in edit mode
            >
              <p className="ps-5 paragraph-lead-id">
                Lead ID - <span className="text-primary "  >
                 {installDetails.leadId} </span>{" "}
                <span className="lead-start-date">
                  {" "}
                  Lead Started Date -{" "}
                  <span className="text-primary">
                    {formatDate(installDetails.createdDate)}
                    
                    </span>
                </span>{" "}
              </p>
            </Row>
            <Row className="ms-3">
              <Col sm={12} md={6} className="text-start ">
                <lable>Customer Name</lable>
                <br />
                <input
  type="text"
  name="installcustomerName"
  placeholder="Enter Customer Name"
  className="form-input"
  style={{ textTransform: "capitalize" }}
  value={installDetails.installcustomerName}
  onChange={handleChange}
  disabled={!isEditable}
/>

              </Col>

              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>
                      Contact Number
                      <sup>
                        <FaStarOfLife size={7} />
                      </sup>
                    </lable>
                    <br />
                    <input
                      type="tel"
                      // disabled={!isEditMode}
                      readOnly
                      disabled={!isEditable}


                      name="installcontactNum"
                      value={installDetails.installcontactNum}     
                                   onChange={handleChange}
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      placeholder="Enter Phone Number"
                      className="form-input"
                      
                      maxLength={10}
                      required

                    />


                  </Col>

                  <Col xs={12} md={6} className="text-start">
                    <lable>Alternate Number </lable>
                    <br />
                    <input
                      type="tel"
                    disabled={!isEditable}


                      name="installalternateNum"
                      value={installDetails.installalternateNum}     
                                   onChange={handleChange}
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      maxLength={10}

                      className="form-input"
                      placeholder="Enter Phone Number"

                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="ms-3">
              <Col xs={12} md={6} className="text-start">
                <lable> Address</lable>
                <br />
                <textarea
                disabled={!isEditable}


                  type="text"
                  name="installaddress"
                  value={installDetails.installaddress}     
                               onChange={handleChange}   

                  style={{ textTransform: "capitalize", resize: "none" }}
                  className=" box address-install"
                  placeholder="Enter  Address"
                />
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Location</lable>
                    <br />
                    <input
                    name="installlocation"
                    value={installDetails.installlocation}     
                                 onChange={handleChange}  
                               disabled={!isEditable}


                      style={{ textTransform: "capitalize" }}
                      className="form-input"
                      type="text"
                      placeholder="Enter Location"
                    
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Lead Source</lable>
                    <br />

                    <select
                     disabled={!isEditable}

 
                      class="dropbtn form-input-select"
                      name="installleadSource"
                      value={installDetails.installleadSource}     
                                   onChange={handleChange}

                    >
                      <option value="">Select</option>

                      {rows.map((data, i) => {
                            return <option>{data.leadSource}</option>;
                          })}

                      
                    </select>
                  </Col>
                </Row>
                <Row>
                 <Col md={6} sm={12} className="text-start">
                                   <label>Sales Name</label>
                 
                  <select
  disabled={!isEditable}
  value={installDetails.installsalesName?._id?.toString() || ""}
  onChange={(e) => {
    const selected = names.find((staff) => staff._id === e.target.value);
    setinstallDetails((prev) => ({
      ...prev,
      installsalesName: selected
        ? {
            _id: selected._id,
            staffName: selected.staffName?.trim() || "",
          }
        : {
            _id: "",
            staffName: "",
          },
    }));
  }}
  className="dropbtn form-input-select"
>
  <option value="">Select</option>
  {names.map((staff) => (
    <option key={staff._id} value={staff._id}>
      {staff.staffName?.trim()}
    </option>
  ))}
</select>

                                   </Col>

                  <Col xs={12} md={6} className="text-start">
                    <label></label>
                    <input
                    disabled={!isEditable}


                      type="button"
                                   onChange={handleChange}

                      value="Plan details"
                      onClick={() => setIsOpenplan(true)}
                      className="form-input converted-form plandetails-form "
                    



                    />




                    {isOpenplan && (
                      <div className="overlay1">
                        <div className="modal1">
                          <Container>
                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Speed</lable>
                                    <br />
                                    <input
                                      type="text"
                                      className="form-input overlay2"
                                      placeholder="Enter Plan Speed"
                                      name="installplanSpeed"
                      value={installDetails.installplanDetails.installplanSpeed}     
                      onChange={handlePlanChange}
                                    />
                                  </Col>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Month</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      name="installplanMonth"
                                      value={installDetails.installplanDetails.installplanMonth}     
                                      onChange={handlePlanChange}

                                      className="form-input overlay2"
                                      placeholder="Enter Plan Month"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Amount</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      name="installplanAmount"
                                      value={installDetails.installplanDetails.installplanAmount}     
                                      onChange={handlePlanChange}
                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>

                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Static Ip Cost </lable>
                                    <br />
                                    <input
                                      type="tel"
                                      name="installstaticIpCost"
                      value={installDetails.installplanDetails.installstaticIpCost}     
                      onChange={handlePlanChange}

                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Fiber Cable Meter</lable>
                                    <br />
                                    <input
                                      type="tel"

                                      name="installfiberCableMeter"
                                      value={installDetails.installplanDetails.installfiberCableMeter}     
                                      onChange={handlePlanChange}

                                      className="form-input overlay2"
                                      placeholder="Enter Meter"
                                    />
                                  </Col>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Installation Cost</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      name="installinstalationCost"
                      value={installDetails.installplanDetails.installinstalationCost}     
                      onChange={handlePlanChange}
                                    

                                      className="form-input overlay2"
                                      placeholder="Enter installation Cost"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row>
                                                                <Col xs={12} md={6} className="text-start">
                                 <label>Router Model</label>
                                 <br />
                                 <select
                                   value={installDetails.installplanDetails.installrouterModel || ""}
                                   onChange={handlePlanChange}
                                   name="installrouterModel"
                                   className="dropbtn form-input-select overlay2" // ✅ fixed `className`
                                 >
                                   <option value="">Select</option>
                                   {routerMaterial.map((item) => (
                                     <option key={item._id} value={item.materialType}>
                                       {item.materialType}
                                     </option>
                                   ))}
                                 </select>
                               </Col>
                               
                               
                                                                 <Col xs={12} md={6} className="text-start">
                                                                   <lable>Router Cost </lable>
                                                                   <br />
                                                                   <input
                                                                     type="tel"
                                                                     value={installDetails.installplanDetails.installrouterCost} onChange={handlePlanChange}
                                                                     name="installrouterCost"
                               
                                                                     className="form-input overlay2"
                                                                     placeholder="Enter installation Cost"
                                                                   />
                                                                 </Col>
                                                               </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Ott Pack Meter</lable>
                                    <br />
                                   <select
                                      value={installDetails.installplanDetails.installottPackDetails}
                                      onChange={handlePlanChange}
                                      name="installottPackDetails"
                                      className="dropbtn form-input-select overlay2"
                                    >
                                      <option value="">Select</option>

                                      {ottData.map((ott) => (
                                        <option key={ott._id} value={ott.ottDetail}>
                                          {ott.ottDetail}
                                        </option>
                                      ))}
                                    </select>
                                  </Col>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Others</lable>
                                    <br />
                                    <input
                                      type="text"
                                      name="installothers"
                                      value={installDetails.installplanDetails.installothers}     
                                      onChange={handlePlanChange}

                                      style={{ textTransform: "capitalize" }}
                                      className="form-input overlay2"
                                      placeholder="Enter "
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Others Cost</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      name="installothersCost"
                      value={installDetails.installplanDetails.installothersCost}     
                      onChange={handlePlanChange}
                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>

                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Advance Amount </lable>
                                    <br />



                                    <select

                                      className="form-input-select"
                                      name="installadvanceAmount"
                                      value={installDetails.installplanDetails.installadvanceAmountPay}
                                      onChange={(e) => {
                                        handleChange(e)
                                        if (e.target.value === "Pay") {
                                          setIsOpenAdvancePayment(true);
                                        }
                                      }}
                                    >
                                      <option value="">Select Type</option>
                                      <option value="Unpay">Unpay</option>
                                      <option value="Pay">Pay</option>

                                    </select>

                                    {isOpenAdvancePayment && (
                                      <div className="overlay-advance-payment">
                                        <div className="modal-advance-payment">
                                          <Container>
                                            <Row>
                                              <Col> <h6>Advance Pay</h6></Col>
                                              <Col className="text-end">
                                                <span
                                                  style={{ fontSize: "23px", cursor: "pointer" }}
                                                  onClick={() => setIsOpenAdvancePayment(false)}
                                                >
                                                  <strong>&times;</strong>
                                                </span>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col>
                                                <div>
                                                  <label>Current Date</label>
                                                  <br />
                                                  <input className="form-input" type="date"
                                                    
                                                    name="installcurrentDate"
                                                    value={installDetails.installplanDetails.installadvanceAmount.installcurrentDate}     

                                                    onChange={handleAmountChange}


                                                  />
                                                </div>
                                              </Col>
                                              <Col>
                                                <div>
                                                  <label>Payment Type</label>
                                                  <br />
                                                  <select className="form-input-select"
                                            value={installDetails.installplanDetails.installadvanceAmount.installpaymentType}     
                                            onChange={handleAmountChange}

                                                    name="installpaymentType"
                                                  >
                                                    <option value="">Select Type</option>
                                                    <option value="Private">Private</option>
                                                    <option value="Technology">Technology</option>
                                                    <option value="Cash">Cash</option>
                                                    <option value="Helpdesk">Helpdesk</option>
                                                    <option value="Others">Others</option>
                                                  </select>

                                                </div>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col>
                                                <div>
                                                  <label>Amount</label>
                                                  <br />
                                                  <input className="form-input" placeholder="Rs"
                                                  
                                                    name="installamount"
                                                    // value={installDetails.installplanDetails.installadvanceAmount.installpaymentType || ""}     
                                                    onChange={handleAmountChange}  
        value={
                                                      installDetails
                                                        .installplanDetails
                                                        .installadvanceAmount
                                                        .installamount
                                                    }

                                                  />
                                                </div>
                                              </Col>
                                              <Col>
                                                <div>
                                                  <label>Reference Number</label>
                                                  <br />
                                                  <input className="form-input" placeholder="Enter Reference Number"
                                                    onChange={handleAmountChange}
                                                    value={installDetails.installplanDetails.installadvanceAmount.installreferenceNumber} 
                                                    name="installreferenceNumber"    
    

                                                  />
                                                </div>
                                              </Col>
                                            </Row>

                                            <Row className="text-end mt-5">
                                              <Col className="text-start">
                                                <button className="black-btn " onClick={() => setIsOpenAdvancePayment(false)}>Cancel</button>
                                              </Col>
                                              <Col className="text-end">
                                                <button className="blue-btn ms-5" onClick={() => setIsOpenAdvancePayment(false)}>Submit</button>
                                              </Col>



                                            </Row>
                                          </Container>
                                        </div>
                                      </div>
                                    )}




                                    {/* </select> */}
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <div className="button-group1">
                              <button
                                type="button"
                                className="black-btn"
                                onClick={() => setIsOpenplan(false)}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="ok-btn1"
                                onClick={() => setIsOpenplan(false)}
                              >
                                OK
                              </button>
                            </div>
                          </Container>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="ms-3">
              <Col xs={12} md={6} className="text-start">
                <lable>Mail ID</lable>
                <br />
                <input
                   value={installDetails.installemailId}     
                   onChange={handleChange} 
                   name="installemailId" 
                 disabled={!isEditable}



                  type="email"
                  placeholder="Enter Email ID"
                  className="form-input "
                
                />
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Next Follow Up Date</lable>
                    <br />
                    <input
                       value={installDetails.installnextFollowUpDate}     
                       onChange={handleChange} 
                       name="installnextFollowUpDate" 

                      className="field form-input"
                    disabled={!isEditable}



                      type="date"
                     
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Lead Status</lable>
                    <br />
                   <input
  style={{
    backgroundColor:
      installDetails.leadStatus === "Open"
        ? "#fbdc6e"
        : installDetails.leadStatus === "Cancelled"
        ? "#f07c7c"
        : installDetails.leadStatus === "Progress"
        ? "#a7a7a7"
        : installDetails.leadStatus === "Completed"
        ? "#b0e9bd"
        : "",
    color:
      installDetails.leadStatus === "Open"
        ? "rgb(94, 94, 14)"
        : installDetails.leadStatus === "Cancelled"
        ? "#a73535"
        : installDetails.leadStatus === "Progress"
        ? "black"
        : installDetails.leadStatus === "Completed"
        ? "#2c693a"
        : "",
  }}
  type="button"
  onChange={handleChange}
  name="installLeadStatus"
  disabled={!isEditable}
  onClick={() => setIsOpenConverted(true)}
  className="form-input converted-form"
  value={installDetails.leadStatus || ""}
/>




                    {isOpenConverted && (
                      <div className="overlay1-converted">
                        <div className="modal1-converted">
                          <Container>
                            <button
                              className="close-btn1"
                              onClick={() => setIsOpenConverted(false)}
                            >
                              <span style={{ fontSize: "20px" }}>
                                {" "}
                                &times;{" "}
                              </span>
                            </button>

                            <div className="open-button border">
                              <h5>{installDetails.leadStatus}</h5>
                            </div>

                            <textarea
                              style={{
                                textTransform: "capitalize",
                                resize: "none",
                              }}

                              placeholder="Enter Notes"
                              className="converted-textbox"
                              name="installnotes"
                              onChange={handleLeadChange}
                              value={installDetails.installleadStatus.installnotes}     



                            />
                            <div className="upload-section">
                              <label className="upload-btn">
                                <FiUpload className="upload-icon" />
                                Upload Image
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={handleFileChange}


                                  hidden
                                />
                              </label>
                              {selectedFile && (
                                <p className="file-name">{selectedFile.name}</p>
                              )}
                            </div>

                            <Row>
                              <Col className="date-update-textbox">
                                <label>Next Follow Up Date</label>
                                <br />
                                <input
                                  type="date"
                                  className="field form-input"
                                  value={installDetails.installleadStatus.installLeadStatusnextFollowUpDate}     
                                  onChange={handleLeadChange} 
                                  name="installnextFollowUpDate" 

                                />
                              </Col>
                              <Col className="uploadbtn-install">
                                <button type="button" className="blue-btn"
                                  onClick={() => setIsOpenConverted(false)}>
                                  Upload
                                </button>
                              </Col>
                            </Row>
                          </Container>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
                </form>
            </Container>
    </div>
  )
}
